module.exports = __webpack_public_path__ + "h5/img/Sierra.f1007619.jpg";